import React from 'react'
import PropTypes from 'prop-types'

import './Editor.scss'

import runnerStyles from './Runner.module.scss'

const Editor = ({ codeToRun }) => {
  return (
    <div className="c-editor">
      <editor-wc
        class="c-editor__wc"
        identifier="bridge-prototype"
        host_styles={JSON.stringify([runnerStyles.toString()])}
        code={codeToRun}
        output_only
        output_panels={JSON.stringify(['visual'])}
        data-editor-target="editor"
        theme="light"
      >
        <p className="c-editor__loading">
          Please wait while the editor loads...
        </p>
      </editor-wc>
    </div>
  )
}

Editor.propTypes = {
  codeToRun: PropTypes.string.isRequired,
}

export default Editor
